import logo from './logo.svg';
import './App.css';
import DashboardDemandeur from './pages/DashboarDemandeur';
import DashboardAdmin from './pages/dashboard';
import useGlobale from './components/global'



  function App() {
  const { user } = useGlobale();
  return (
    <>
      {user && user.is_superuser ? (
        <DashboardAdmin />
      ) : (
        <DashboardDemandeur />
      )}
    </>
  );
}

export default App;
